export const defaultDealerUser = {
    siteUserId: null,
    role: 'Dealer',
    fullName: '',
    email: '',
    phone: '',
    pmFullName: '',
    pmContactPhone: '',
    pmContactEmail: '',
    salesFullName: '',
    salesContactPhone: '',
    salesContactEmail: '',
    companyName: '',
    notify: false
};

